import React, { Component } from "react";
import { Table, Tag, Tooltip } from "antd";
import moment from "moment";
import "moment/locale/es";
import { ModalItem } from "../../../../Components/Items";

moment.locale("es");

// Aviso del complemento `avisoVentasPorEntregarVendedor`: lista las ventas del
// usuario (como vendedor) en estado 1 (Sin entregar) o 2 (Entregado parcialmente).
class ModalVentasPorEntregar extends Component {
  columns = [
    {
      title: "Número",
      dataIndex: "numero",
      key: "numero",
      width: "18%",
      render: (value, record) => (
        <div>
          <div>{value}</div>
          {record.ordenDeCompra && (
            <div style={{ fontSize: 11, color: "#666" }}>OC: {record.ordenDeCompra}</div>
          )}
        </div>
      ),
    },
    {
      title: "Cliente",
      dataIndex: "clienteNombre",
      key: "clienteNombre",
      ellipsis: true,
    },
    {
      title: "Fecha",
      dataIndex: "fechaVenta",
      key: "fechaVenta",
      width: "14%",
      align: "center",
      render: (value) => (value ? moment(value).format("DD/MM/YYYY") : ""),
    },
    {
      title: "Entrega estimada",
      dataIndex: "fechaEntregaEstimada",
      key: "fechaEntregaEstimada",
      width: "16%",
      align: "center",
      render: (value) => {
        if (!value) return <span style={{ color: "#999" }}>Sin fecha</span>;
        const vencida = moment(value).isBefore(moment().startOf("day"), "day");
        return vencida ? (
          <Tooltip title="La fecha estimada de entrega ya pasó">
            <span style={{ color: "#ff4d4f", fontWeight: 600 }}>{moment(value).format("DD/MM/YYYY")}</span>
          </Tooltip>
        ) : (
          moment(value).format("DD/MM/YYYY")
        );
      },
    },
    {
      title: "Estado",
      dataIndex: "estado",
      key: "estado",
      width: "16%",
      align: "center",
      render: (value) =>
        value === 2 ? (
          <Tag color="orange" className="square-tag">Entregado par.</Tag>
        ) : (
          <Tag color="blue" className="square-tag">Sin entregar</Tag>
        ),
    },
  ];

  render() {
    const { visible, ventas = [], total = 0, onCancel, onVerVenta } = this.props;

    return (
      <ModalItem
        title={`Tienes ${total} ${total === 1 ? "venta" : "ventas"} por entregar`}
        visible={visible}
        onCancel={onCancel}
        paddingTop
        width={900}
      >
        <div style={{ marginBottom: 8, color: "#666", fontSize: 13 }}>
          Ventas en las que eres el vendedor y que siguen sin entregar o entregadas parcialmente.
          {total > ventas.length && ` Se muestran las primeras ${ventas.length} de ${total}.`}
          {" "}Doble clic para abrir la venta.
        </div>
        <Table
          size="small"
          rowKey="_id"
          columns={this.columns}
          dataSource={ventas}
          pagination={{ pageSize: 10, hideOnSinglePage: true, showSizeChanger: false }}
          onRow={(record) => ({
            onDoubleClick: () => onVerVenta(record._id),
            style: { cursor: "pointer" },
          })}
        />
      </ModalItem>
    );
  }
}

export default ModalVentasPorEntregar;
